export default __webpack_public_path__ + "static/media/avista.09b23b13.svg";